import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../../../../juristec-ui/core/Checkbox';

import {
  MainContainer,
  HeaderContainer,
  TextContainer,
  CheckboxInputWrapper,
} from './styled/Policy.styled';

import UseTermsLM from './UseTermsLM';
import UseTermsTR from './UseTermsTR';
import UseTermsBenner from './UseTermsBenner';

import { formatDateTime } from '../../../../juristec-ui/utils/functions/lab';

const switchUseTerms = () => {
  switch (process.env.REACT_APP_FIREBASE_PROJECT_LABEL) {
    case 'legalone-analytics':
      return <UseTermsTR />;

    case 'benner-metrics':
      return <UseTermsBenner />; // ALTERAÇÃO BENNER: alterar para o componente correto

    default:
      return <UseTermsLM />;
  }
};

const TSTermsContainer = ({
  version, date, checkState, setCheckState, readOnly,
}) => {
  return (
    <MainContainer>
      {readOnly || (
        <HeaderContainer>
          <h3>Termos de Uso</h3>
          <span>
            {`${version}: ${formatDateTime(date)}`}
          </span>
        </HeaderContainer>
      )}
      <TextContainer tabIndex="0">
        {switchUseTerms()}
      </TextContainer>
      {readOnly || (
        <CheckboxInputWrapper>
          <Checkbox
            text="Eu concordo com os Termos de Uso"
            color="secondary"
            variant="outlined"
            checked={checkState}
            handleCheckboxChange={(check) => setCheckState(check)}
          />
        </CheckboxInputWrapper>
      )}
    </MainContainer>
  );
};

TSTermsContainer.propTypes = {
  /**
   * The version of the policy
   */
  version: PropTypes.string,
  /**
   * The date of the policy
   */
  date: PropTypes.shape({
    nanoseconds: PropTypes.number,
    seconds: PropTypes.number,
  }),
  /**
   * A boolean that represents the state of the checkbox
   */
  checkState: PropTypes.bool,
  /**
   * A function to handle the checkbox check
   */
  setCheckState: PropTypes.func,
  /**
   * A boolean that determines whether or not is show the checkbox
   */
  readOnly: PropTypes.bool,
};

TSTermsContainer.defaultProps = {
  version: '',
  date: {
    nanoseconds: 0,
    seconds: 0,
  },
  checkState: false,
  setCheckState: () => {},
  readOnly: false,
};

export default TSTermsContainer;
